import React, { createContext, ReactNode, useContext } from 'react';

type DbtCloudContextType = {
  dbtInstance: string | undefined | null;
};

const DbtCloudContext = createContext<DbtCloudContextType>({
  dbtInstance: undefined,
});

export const useDbtCloud = () => {
  return useContext(DbtCloudContext);
};

interface DbtCloudProviderProps {
  dbtInstance: string | undefined | null;
  children: ReactNode;
}

export const DbtCloudProvider: React.FC<DbtCloudProviderProps> = ({
  dbtInstance,
  children,
}) => {
  return (
    <DbtCloudContext.Provider value={{ dbtInstance }}>
      {children}
    </DbtCloudContext.Provider>
  );
};
